import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/customCategorys";

export default {
  getModules(id) {
    return httpGet(`/customMenus/list/terminals/${id}`);
  },
  getModule(id) {
    return httpGet(`/customMenus/${id}`);
  },
  postModule(item) {
    return httpPost(`/customMenus`, item);
  },
  sequenceModules(item) {
    return httpPost("/customMenus/sequence", item);
  },
  getItems(id) {
    return httpGet(`${path}/${id}`);
  },
  save(id, item) {
    return httpPost(`${path}/${id}/customCategory`, item);
  },
  saveWithFoodKinds(item) {
    return httpPost(`${path}/addBatch/foodKinds`, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  sequence(item) {
    return httpPost(`${path}/priority/position`, item);
  },
  x(moduleId, value) {
    return httpPost(`/modules/${moduleId}/customCategory/x`, { X: value });
  },
};
